<template>
  <div class="container-login d-flex align-items-center">
    <div class="card card-login align-items-stretch">
      <div class="card-login-logo text-center pt-4">
        <img src="../../img/vendoscope-logo.png">
      </div>

      <login-index v-if="step == 'index'" @userActive="onUserActive"></login-index>

      <login-password
        v-if="step == 'password'"
        :auth="auth"
        :password_sent="password_sent"
        :password_debug="password_debug"
        @sms="onSms"
        @remindPassword="step = 'remind'"
        @cancel="step = 'index'"></login-password>

      <login-remind
        v-if="step == 'remind'"
        :email="auth.email"
        @remindPassword="onRemindPassword"
        @cancel="step = 'password'"></login-remind>

      <login-sms v-if="step == 'sms'" @cancel="step = 'index'"></login-sms>

      <div class="card-footer ">
        <div class="d-flex">
          <span class="small d-flex align-items-center">Телефон:  <a href="tel:78007003443">8 (800) 700-34-43</a></span>
          <a href="https://gkv24.ru/online/vendoscope" class="btn btn-warning btn-sm lead ml-auto" style="font-size: 0.8rem;" target="_blank">Онлайн чат</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import LoginIndex from '../components/login/index.vue'
  import LoginPassword from '../components/login/password.vue'
  import LoginSms from '../components/login/sms.vue'
  import LoginRemind from '../components/login/remind.vue'
  export default {
    metaInfo: {title: 'Авторизация'},
    data () {
      return {
        step: 'index',
        auth: {},
        password_sent: null,
        password_debug: null,
      }
    },
    components: {
      LoginIndex,
      LoginPassword,
      LoginSms,
      LoginRemind,
    },
    methods: {
      onLogin () {
        this.$router.push('/')
      },
      onUserActive (auth, data) {
        this.auth = auth
        this.password_sent = data.password_sent
        this.password_debug = data.password_debug
        this.step = 'password'
      },
      onSms (auth) {
        this.auth = auth;
        this.step = 'sms'
      },
      onRemindPassword (auth) {
        this.auth = auth
        this.password_sent = true
        this.step = 'password'
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/login.vue